module.exports = __webpack_public_path__ + "assets/img/3_1386_big.e68ce28a.jpg";